__turbopack_context__.v({
  "addTask": "command-module__GCu5SG__addTask",
  "agentTools": "command-module__GCu5SG__agentTools",
  "arrival": "command-module__GCu5SG__arrival",
  "arrive": "command-module__GCu5SG__arrive",
  "assistantPending": "command-module__GCu5SG__assistantPending",
  "atrium": "command-module__GCu5SG__atrium",
  "attachments": "command-module__GCu5SG__attachments",
  "avatar": "command-module__GCu5SG__avatar",
  "backToLab": "command-module__GCu5SG__backToLab",
  "brand": "command-module__GCu5SG__brand",
  "buttonIcon": "command-module__GCu5SG__buttonIcon",
  "calm": "command-module__GCu5SG__calm",
  "captionLine": "command-module__GCu5SG__captionLine",
  "channelTabs": "command-module__GCu5SG__channelTabs",
  "chatChannels": "command-module__GCu5SG__chatChannels",
  "chatContent": "command-module__GCu5SG__chatContent",
  "chatControls": "command-module__GCu5SG__chatControls",
  "chatFeedback": "command-module__GCu5SG__chatFeedback",
  "chatRestore": "command-module__GCu5SG__chatRestore",
  "chatSearch": "command-module__GCu5SG__chatSearch",
  "chatSettings": "command-module__GCu5SG__chatSettings",
  "chatUtility": "command-module__GCu5SG__chatUtility",
  "checkbox": "command-module__GCu5SG__checkbox",
  "composer": "command-module__GCu5SG__composer",
  "composerFoot": "command-module__GCu5SG__composerFoot",
  "connection": "command-module__GCu5SG__connection",
  "contextChip": "command-module__GCu5SG__contextChip",
  "controlsButton": "command-module__GCu5SG__controlsButton",
  "conversation": "command-module__GCu5SG__conversation",
  "conversationBody": "command-module__GCu5SG__conversationBody",
  "conversationHeader": "command-module__GCu5SG__conversationHeader",
  "copyMessage": "command-module__GCu5SG__copyMessage",
  "dockBadge": "command-module__GCu5SG__dockBadge",
  "emptyConversation": "command-module__GCu5SG__emptyConversation",
  "enter": "command-module__GCu5SG__enter",
  "eyebrow": "command-module__GCu5SG__eyebrow",
  "footer": "command-module__GCu5SG__footer",
  "footerActions": "command-module__GCu5SG__footerActions",
  "header": "command-module__GCu5SG__header",
  "headerRight": "command-module__GCu5SG__headerRight",
  "helpFoot": "command-module__GCu5SG__helpFoot",
  "helpRoutes": "command-module__GCu5SG__helpRoutes",
  "hudHost": "command-module__GCu5SG__hudHost",
  "inlineError": "command-module__GCu5SG__inlineError",
  "inviteButton": "command-module__GCu5SG__inviteButton",
  "invitePanel": "command-module__GCu5SG__invitePanel",
  "labAvatar": "command-module__GCu5SG__labAvatar",
  "labPresence": "command-module__GCu5SG__labPresence",
  "labWorking": "command-module__GCu5SG__labWorking",
  "memberAvatar": "command-module__GCu5SG__memberAvatar",
  "memberRow": "command-module__GCu5SG__memberRow",
  "message": "command-module__GCu5SG__message",
  "messageAvatar": "command-module__GCu5SG__messageAvatar",
  "messageDelete": "command-module__GCu5SG__messageDelete",
  "messageEdit": "command-module__GCu5SG__messageEdit",
  "messageExplanation": "command-module__GCu5SG__messageExplanation",
  "messageInstrument": "command-module__GCu5SG__messageInstrument",
  "messageMeta": "command-module__GCu5SG__messageMeta",
  "messageTools": "command-module__GCu5SG__messageTools",
  "mission": "command-module__GCu5SG__mission",
  "missionProgress": "command-module__GCu5SG__missionProgress",
  "mobileWayfinding": "command-module__GCu5SG__mobileWayfinding",
  "moveMessage": "command-module__GCu5SG__moveMessage",
  "nav": "command-module__GCu5SG__nav",
  "navigationHelp": "command-module__GCu5SG__navigationHelp",
  "nextStep": "command-module__GCu5SG__nextStep",
  "notice": "command-module__GCu5SG__notice",
  "parentLink": "command-module__GCu5SG__parentLink",
  "perspective": "command-module__GCu5SG__perspective",
  "pinnedLabel": "command-module__GCu5SG__pinnedLabel",
  "pinnedWidgets": "command-module__GCu5SG__pinnedWidgets",
  "primary": "command-module__GCu5SG__primary",
  "privateMessage": "command-module__GCu5SG__privateMessage",
  "progressTrack": "command-module__GCu5SG__progressTrack",
  "pulsePanel": "command-module__GCu5SG__pulsePanel",
  "quiet": "command-module__GCu5SG__quiet",
  "regularChat": "command-module__GCu5SG__regularChat",
  "roomDock": "command-module__GCu5SG__roomDock",
  "scene": "command-module__GCu5SG__scene",
  "sceneBackdrop": "command-module__GCu5SG__sceneBackdrop",
  "sceneCaption": "command-module__GCu5SG__sceneCaption",
  "scopeToggle": "command-module__GCu5SG__scopeToggle",
  "scrim": "command-module__GCu5SG__scrim",
  "searchEmpty": "command-module__GCu5SG__searchEmpty",
  "sectionNo": "command-module__GCu5SG__sectionNo",
  "sectionTitle": "command-module__GCu5SG__sectionTitle",
  "selectedTask": "command-module__GCu5SG__selectedTask",
  "selectedTop": "command-module__GCu5SG__selectedTop",
  "shareAnswer": "command-module__GCu5SG__shareAnswer",
  "spatialContext": "command-module__GCu5SG__spatialContext",
  "srOnly": "command-module__GCu5SG__srOnly",
  "startLab": "command-module__GCu5SG__startLab",
  "subtitle": "command-module__GCu5SG__subtitle",
  "taskActions": "command-module__GCu5SG__taskActions",
  "taskForm": "command-module__GCu5SG__taskForm",
  "taskIndex": "command-module__GCu5SG__taskIndex",
  "taskRow": "command-module__GCu5SG__taskRow",
  "taskSection": "command-module__GCu5SG__taskSection",
  "taskState": "command-module__GCu5SG__taskState",
  "taskViews": "command-module__GCu5SG__taskViews",
  "tasks": "command-module__GCu5SG__tasks",
  "teamSkills": "command-module__GCu5SG__teamSkills",
  "textButton": "command-module__GCu5SG__textButton",
  "unfold": "command-module__GCu5SG__unfold",
  "unreadJump": "command-module__GCu5SG__unreadJump",
  "wideControl": "command-module__GCu5SG__wideControl",
  "workshopChatMount": "command-module__GCu5SG__workshopChatMount",
  "workshopHost": "command-module__GCu5SG__workshopHost",
  "workspace": "command-module__GCu5SG__workspace",
});
